import { Grid } from "@mui/material";
import React from "react";
import {
  Button,
  Card,
  Form,
  GoBack,
  MenuItem,
  Title,
} from "../../../../../components";
import {
  ControlledTextField,
  ZipCodeTextField,
} from "../../../../../components/inputs";
import { estados } from "../../../../../constants/generic.constants";
import Stepper from "../../../preenchimento/Stepper";

const DadosEnderecoOutrosProponentesFintechsForm = ({
  fluxo,
  formProps,
  handleSubmit,
  handleZipCodeBlurred,
  submitting,
  events,
  makeGoTo,
}) => {
  return (
    <Grid item container justifyContent={"center"} mb={4}>
      <Grid item container spacing={3} maxWidth={704}>
        <GoBack
          handleClick={makeGoTo(50)}
          text={"Preencha as informações do proponente"}
        />
        <Grid item container alignItems={"center"}>
          <Grid item flex={1}>
            <Stepper current={1} events={events} fluxo={fluxo} />
          </Grid>
        </Grid>
        <Grid item container>
          <Grid item>
            <Card>
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Title as={"h5"}>Endereço Residencial</Title>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ControlledTextField
                      label="CEP"
                      name={"endereco.cep"}
                      formProps={formProps}
                      onBlur={handleZipCodeBlurred}
                      InputProps={{
                        inputComponent: ZipCodeTextField,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <ControlledTextField
                      label="Endereço"
                      name={"endereco.logradouro"}
                      inputProps={{ maxLength: 100 }}
                      formProps={formProps}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ControlledTextField
                      label="Número"
                      name={"endereco.numero"}
                      inputProps={{ maxLength: 7 }}
                      formProps={formProps}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ControlledTextField
                      label="Complemento"
                      name={"endereco.complemento"}
                      inputProps={{ maxLength: 30 }}
                      formProps={formProps}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ControlledTextField
                      label="Bairro"
                      name={"endereco.bairro"}
                      inputProps={{ maxLength: 40 }}
                      formProps={formProps}
                    />
                  </Grid>
                  <Grid item xs={9}>
                    <ControlledTextField
                      label="Município"
                      name={"endereco.municipio"}
                      inputProps={{ maxLength: 60 }}
                      formProps={formProps}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <ControlledTextField
                      label="UF"
                      name={"endereco.uf"}
                      select
                      formProps={formProps}
                    >
                      {estados.map((state) => (
                        <MenuItem key={state} value={state}>
                          {state}
                        </MenuItem>
                      ))}
                    </ControlledTextField>
                  </Grid>
                  <Grid item container justifyContent={"center"} mt={1}>
                    <Grid item xs={12} md={4}>
                      <Button type={"submit"} fullWidth loading={submitting}>
                        CONTINUAR
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DadosEnderecoOutrosProponentesFintechsForm;
